import { Container, Grid } from "@mui/material";
import { SingleProduct } from "../single-product.js";
import React from "react";
export const GridLayout = ({ products, showPrice = true, }) => (React.createElement(Container, { maxWidth: "xl" },
    React.createElement(Grid, { alignItems: "center", container: true, spacing: { xs: 4, md: 6, lg: 10 } }, products.map((product) => (React.createElement(Grid, { item: true, key: `related-product-grid-${product.slug}`, sm: 3 },
        React.createElement(SingleProduct, { product: product, showPrice: showPrice })))))));
//# sourceMappingURL=grid-layout.js.map